import { memo } from "react";
import { Grid, Box } from "@mui/material";
import MainEcommerce from "../components/ecommerces/MainEcommerce";
// import EcommerceConfig from "../components/ecommerces/EcommerceConfig.jsx";


const EcommerceConfiguration = (props) => {
  return (
    <>
      <Grid item xs={12} className="mg-t-20">
        <h2>Configuraciones E-commerce</h2>
      </Grid>

      <Box sx={{ width: "100%", typography: "body1" }}>
        <MainEcommerce />
      </Box>
    </>
  );
};

export default memo(EcommerceConfiguration);
